import { useRouteQuery } from '@/common/route/useRouteQuery';
import { StringUtils } from '@/common/utils/stringUtils';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useRfmGroupList } from '@/modules/rfm/group/model/list';
import { rfmService } from '@/services/rfm';

export function useRfmRecencyList() {
    const crudAction = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            groupId: { type: 'number', default: null }
        },
        onChange: () => fetchList()
    });

    const { rfmGroupNameMap, rfmGroupOptions, fetchRfmGroupAll } = useRfmGroupList();

    const { list, total, fetchList } = useBaseListView({
        request: rfmService.recency.list,
        paramsBuilder: () => query,
        hooks: {
            loadInitialData: async () => await fetchRfmGroupAll(),
            onSuccess: updateQueryToRoute,
            canFetch: () => query.groupId !== null,
            transformResponse: (list: any[]) =>
                list.map((item: any) => ({
                    ...item,
                    groupName: rfmGroupNameMap.value.get(item.groupId) || StringUtils.Characters.Empty
                }))
        }
    });

    const { list: recencyAll, fetchList: fetchRecencyAll } = useBaseListView({ request: rfmService.recency.list });

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: rfmService.recency.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, rfmGroupOptions, query, actions, recencyAll, fetchRecencyAll };
}
